<template>
	<vue-page-transition name="fade">
		<router-view />
	</vue-page-transition>
</template>

<style>
</style>
